import history from './history';
import Routes from './Routes';

export * from './helpers';
export {history};
export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.tsx